export const QR_ELEMENT_ID = "invoice-qrcode-modal-svg";

export enum TabId {
  Card = "card",
  QrCode = "qrCode",
}

export const qrTabs = [
  { id: TabId.Card, label: "Готова картка" },
  { id: TabId.QrCode, label: "Тільки QR-код" },
];
